import { Component, NgZone, OnInit } from '@angular/core'
import { NavigationEnd, Router, RouterModule } from '@angular/router'
import { MatTabsModule } from '@angular/material/tabs'
import { MatSidenavModule } from '@angular/material/sidenav'
import { MatToolbarModule } from '@angular/material/toolbar'
import { FlexLayoutModule } from '@angular/flex-layout'
import { MatIconModule } from '@angular/material/icon'
import { CommonModule } from '@angular/common'
import { AuthService } from './core/services/auth.service'
import { MatButtonModule } from '@angular/material/button'
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu'
import { MatDividerModule } from '@angular/material/divider'
import { PARTNERS_DATA } from './shared/components/about/about.component'
import { filter } from 'rxjs'
import { MatTooltipModule } from '@angular/material/tooltip'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { trigger, transition, style, animate } from '@angular/animations'

@Component({
  selector: 'overlay-component',
  standalone: true,
  imports: [
    MatTabsModule,
    RouterModule,
    CommonModule,
    MatSidenavModule,
    MatMenuModule,
    MatIconModule,
    MatButtonModule,
    FlexLayoutModule,
    MatDividerModule,
    MatToolbarModule,
    MatTooltipModule
  ],
  templateUrl: './overlay.component.html',
  styleUrl: './overlay.component.css',
  animations: [
    trigger('slideFade', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(-10px)' }),
        animate('200ms ease-out', style({ opacity: 1, transform: 'translateY(0)' }))
      ]),
      transition(':leave', [
        animate('150ms ease-in', style({ opacity: 0, transform: 'translateY(-10px)' }))
      ])
    ])
  ]
})
export class OverlayComponent{
  constructor(
    public auth:AuthService,
    private router: Router, 
    private ngZone: NgZone
  ){
    this.auth.autoLogin()
    this.router.events
    .pipe(filter(event => event instanceof NavigationEnd))
    .subscribe(() => {
      requestAnimationFrame(() => {
        document.querySelector('main')?.scrollTo({ top: 0, behavior: 'smooth' })
      })
    })
  }
  partners = PARTNERS_DATA.slice(0,5)
  activePanel: 'news' | 'services' | null = null
  closeTimeout: any

  openPanel(panel: 'news' | 'services') {
    clearTimeout(this.closeTimeout)
    this.activePanel = panel
  }

  closePanel() {
    this.closeTimeout = setTimeout(() => {
      this.activePanel = null
    }, 100)
  }
}

